import { render, staticRenderFns } from "./SelectProduct.vue?vue&type=template&id=4805248e&scoped=true"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"
import style0 from "./SelectProduct.vue?vue&type=style&index=0&id=4805248e&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4805248e",
  null
  
)

export default component.exports